module.exports = __webpack_public_path__ + "static/img/html.03c2ab98.png";